import { Country } from '../../../types'
import { CurrencyAndCountry } from './EmployeeFilterModal'

export const availableCountries = (filterData: CurrencyAndCountry[]): Country[] => {
  if (filterData && filterData.length > 0) {
    const countries = filterData.flatMap((employee) => (employee.country ? employee.country : []))
    return [...new Set(countries)]
  }
  return []
}
